import schneider from '../img/logo/wscheneider.webp';
import siemens from '../img/logo/wsiemens.webp';
import eaton from '../img/logo/weaton.webp';
import ge from '../img/logo/wge.webp';
import hubbell from '../img/logo/whubbell.webp';
import leviton from '../img/logo/wleviton.webp';
import rockwell from '../img/logo/wra.webp';
import sylvania from '../img/logo/wsylvana.webp';
import threeM from '../img/logo/w3m.webp';
import abb from '../img/logo/wabb.webp';
import circutor from '../img/logo/wcircutor.webp';
import elast from '../img/logo/welast.webp';
import legrand from '../img/logo/wlegran.webp';
import miguelez from '../img/logo/wmige.webp';
import squared from '../img/logo/wsquared.webp';
import tomas from '../img/logo/wtomas.webp';
import nvent from '../img/logo/wvent.webp';
import metcom from '../img/logo/metcom.webp';

export const BRANDS = [
  { name: 'Schneider Electric', logo: schneider, url: 'https://www.se.com/pa/es/' },
  { name: 'Siemens', logo: siemens, url: 'https://www.siemens.com/global/en.html' },
  { name: 'Eaton', logo: eaton, url: 'https://www.eaton.com/country.html' },
  { name: 'GE', logo: ge, url: 'https://www.ge.com/latam/' },
  { name: 'Hubbell', logo: hubbell, url: 'https://www.hubbell.com/' },
  { name: 'Leviton', logo: leviton, url: 'https://www.leviton.com/es/homepage' },
  { name: 'Rockwell Automation', logo: rockwell, url: 'https://www.rockwellautomation.com/es-co.html' },
  { name: 'Sylvania Lighting', logo: sylvania, url: 'https://www.sylvania-lighting.com/offices/panama/' },
  { name: '3M', logo: threeM, url: 'https://www.3m.com.pa/3M/es_PA/inicio/' },
  { name: 'ABB', logo: abb, url: 'https://new.abb.com/south-america' },
  { name: 'Circutor', logo: circutor, url: 'https://circutor.com/' },
  { name: 'Legrand', logo: legrand, url: 'https://www.legrand.es/' },
  { name: 'Miguélez', logo: miguelez, url: 'https://www.miguelez.com/pa' },
  { name: 'nVent', logo: nvent, url: 'https://www.nvent.com/es-pa/' },
  { name: 'Metcom', logo: metcom, url: 'https://www.metcom-solutions.com/en/' },
  // Sin URL confirmada: se muestran sin enlace, nunca con href="#".
  { name: 'Elast', logo: elast },
  { name: 'Square D', logo: squared },
  { name: 'Thomas & Betts', logo: tomas },
];
